import React, { useState, useEffect } from 'react';
import { Button, Modal, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaPencilAlt } from "react-icons/fa";
import axios from 'axios';

function EnoTable({ caseId }) {
  const inputStyle = {
    border: '2px solid #ccc',
    borderRadius: '4px',
    padding: '8px',
    width: '100px',
    marginBottom: '10px',
  };
  
  const labelStyle = {
    marginLeft: '10px',
  };

  const [show, setShow] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [enclosures, setEnclosures] = useState({
    alginateMandibularImpression: 0,
    alginateMaxillaryImpression: 0,
    approvedProvisionalModel: 0,
    articulator: 0,
    bisqueCrowns: 0,
    biteBlocks: 0,
    biteFork: 0,
    biteRegistration: 0,
    dentureTeeth: 0,
    facebow: 0,
    implantParts: 0,
    mandibularImpression: 0,
    mandibularStudyModel: 0,
    maxillaryImpression: 0,
    maxillaryStudyModel: 0,
    metalFramework: 0,
    nameApprovedProvisionalModel: 0,
    oldCrown: 0,
    opposingModel: 0,
    patientDenturePartial: 0,
    photographs: 0,
    shadeTab: 0,
    tripleTrayImpression: 0,
    waxBiteRegistration: 0,
    waxSetup: 0,
    workingModel: 0,
  });

  useEffect(() => {
    if (show && caseId) {
      const fetchEnclosures = async () => {
        try {
          const response = await axios.get(`https://hms.backend.hiragroupcloud.com/api/cases/${caseId}/enclosures`);
          if (response.data.data.enclosures) {
            setEnclosures(response.data.data.enclosures);
          }
        } catch (error) {
          console.error('Error fetching enclosures:', error);
        }
      };
      fetchEnclosures();
    }
  }, [show, caseId]);

  const handleClose = () => {
    setShow(false);
    setShowSuccessAlert(false);
  };
  
  const handleShow = () => setShow(true);

  const handleInputChange = (field, value) => {
    setEnclosures(prev => ({
      ...prev,
      [field]: Number(value) || 0
    }));
  };

  const handleSave = async () => {
    try {
      await axios.put(`https://hms.backend.hiragroupcloud.com/api/cases/${caseId}/enclosures`, enclosures);
      setShowSuccessAlert(true);
      
      // Hide the alert after 3 seconds
      setTimeout(() => {
        setShowSuccessAlert(false);
      }, 3000);
    } catch (error) {
      console.error('Error saving enclosures:', error);
      alert('Failed to save enclosures. Please try again.');
    }
  };

  const modalBodyStyle = {
    height: '500px',
    overflowY: 'auto',
    position: 'relative',
  };

  return (
    <div className="App">
      <Button
        style={{
          backgroundColor: '#004aad',
          borderColor: '#004aad',
        }}
        onClick={handleShow}>
        <FaPencilAlt style={{ fontSize: '20px' }} />
      </Button>
      
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton style={{ backgroundColor: '#004aad', borderBottom: '2px solid #ccc' }}>
          <Modal.Title style={{ color: 'white', textAlign: "left", display: 'inline-block' }}>Enclosures</Modal.Title>
        </Modal.Header>
        
        <Modal.Body style={modalBodyStyle}>
          {showSuccessAlert && (
            <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible>
              Enclosures saved successfully!
            </Alert>
          )}
          
          <div>
            <input
              type="number"
              value={enclosures.alginateMandibularImpression}
              onChange={(e) => handleInputChange('alginateMandibularImpression', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Alginate Mandibular Impression</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.alginateMaxillaryImpression}
              onChange={(e) => handleInputChange('alginateMaxillaryImpression', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Alginate Maxillary Impression</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.approvedProvisionalModel}
              onChange={(e) => handleInputChange('approvedProvisionalModel', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Approved Provisional Model</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.articulator}
              onChange={(e) => handleInputChange('articulator', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Articulator</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.bisqueCrowns}
              onChange={(e) => handleInputChange('bisqueCrowns', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Bisque Crowns</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.biteBlocks}
              onChange={(e) => handleInputChange('biteBlocks', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Bite Blocks</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.biteFork}
              onChange={(e) => handleInputChange('biteFork', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Bite Fork</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.biteRegistration}
              onChange={(e) => handleInputChange('biteRegistration', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Bite Registration</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.dentureTeeth}
              onChange={(e) => handleInputChange('dentureTeeth', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Denture Teeth</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.facebow}
              onChange={(e) => handleInputChange('facebow', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Facebow</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.implantParts}
              onChange={(e) => handleInputChange('implantParts', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Implant Parts</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.mandibularImpression}
              onChange={(e) => handleInputChange('mandibularImpression', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Mandibular Impression</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.mandibularStudyModel}
              onChange={(e) => handleInputChange('mandibularStudyModel', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Mandibular Study Model</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.maxillaryImpression}
              onChange={(e) => handleInputChange('maxillaryImpression', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Maxillary Impression</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.maxillaryStudyModel}
              onChange={(e) => handleInputChange('maxillaryStudyModel', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Maxillary Study Model</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.metalFramework}
              onChange={(e) => handleInputChange('metalFramework', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Metal Framework</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.nameApprovedProvisionalModel}
              onChange={(e) => handleInputChange('nameApprovedProvisionalModel', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Name Approved Provisional Model</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.oldCrown}
              onChange={(e) => handleInputChange('oldCrown', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Old Crown</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.opposingModel}
              onChange={(e) => handleInputChange('opposingModel', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Opposing Model</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.patientDenturePartial}
              onChange={(e) => handleInputChange('patientDenturePartial', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Patient Denture/Partial</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.photographs}
              onChange={(e) => handleInputChange('photographs', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Photographs</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.shadeTab}
              onChange={(e) => handleInputChange('shadeTab', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Shade Tab</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.tripleTrayImpression}
              onChange={(e) => handleInputChange('tripleTrayImpression', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Triple Tray Impression</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.waxBiteRegistration}
              onChange={(e) => handleInputChange('waxBiteRegistration', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Wax Bite Registration</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.waxSetup}
              onChange={(e) => handleInputChange('waxSetup', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Wax Setup</label></span>
          </div>
          <br />
          
          <div>
            <input
              type="number"
              value={enclosures.workingModel}
              onChange={(e) => handleInputChange('workingModel', e.target.value)}
              style={inputStyle}
            />
            <span><label style={labelStyle}>Working Model</label></span>
          </div>
          <br />
        </Modal.Body>
        
        <Modal.Footer>
          <Button onClick={handleClose} style={{
            backgroundColor: '#004aad',
            borderColor: '#004aad',
          }}>
            Cancel
          </Button>
          <Button onClick={handleSave} style={{
            backgroundColor: '#004aad',
            borderColor: '#004aad',
          }}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default EnoTable;